
import { RevPicker } from '@ds/components/Picker'

import Picker from '../Picker'

import {
  COLS_CLASS_DEFAULT,
  COLS_CLASS_OVERRIDES,
  DISPLAY_SOLD_OUT,
  MAX_PICKER_ITEMS,
} from './PickerGroup.constants'
import translations from './PickerGroup.translations'

export default {
  components: {
    Picker,
    RevPicker,
  },
  props: {
    picker: {
      type: Object,
      default: () => {},
    },
    variantForSelectedPickers: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      displayAllItems: false,
      /**
       * For now, we don't call the endpoint each time we click on a picker. Well, we do for most of them,
       * but when we change only the grade, most of the things are handled client-side, so we need to have this
       * selected mechanism here, that'll still work with every pickers (even the fully API-driven). We won't need this
       * anymore once we'll have condition driven pickers as we'll most probably have to call the endpoint everytime. But for now,
       * let's save some bandwidth.
       * Long term vision: watch productId/hash change in product.vue and re-call the pickers endpoint
       */
      selectedIndex: this.picker.items.findIndex(({ selected }) => !!selected),
    }
  },
  computed: {
    translations: () => translations,

    itemsToDisplay() {
      const { items } = this.picker

      if (this.isItemsLengthHigherThanMax && !this.displayAllItems) {
        return items.slice(0, this.maximumAmountOfItemsToShow)
      }

      return items
    },

    isItemsLengthHigherThanMax() {
      return this.picker.items.length > MAX_PICKER_ITEMS
    },

    remainingItemsCount() {
      return this.picker.items.length - this.maximumAmountOfItemsToShow
    },

    maximumAmountOfItemsToShow() {
      return MAX_PICKER_ITEMS - 1
    },

    togglerLabel() {
      const { showMore, showLess } = this.translations

      return this.displayAllItems
        ? this.$t(showLess)
        : this.$t(showMore, { remaining: this.remainingItemsCount })
    },

    pickerTitle() {
      return this.picker.label
    },

    pickerId() {
      return this.picker.id
    },

    gridColumnsClass() {
      return COLS_CLASS_OVERRIDES[this.pickerId] ?? COLS_CLASS_DEFAULT
    },

    shouldDisplaySoldOut() {
      return DISPLAY_SOLD_OUT.includes(this.pickerId)
    },
  },

  methods: {
    toggleDisplayAllItems() {
      this.displayAllItems = !this.displayAllItems
    },
  },
}
